export default __webpack_public_path__ + "static/media/welcome.0f4a4167.png";